import { makeAutoObservable } from 'mobx'

import { _map } from '../util/Util'

export const loadScript = (path: string) => {
  const script = document.createElement('script')
  script.src = path

  const promise = new Promise((resolve) => {
    script.onload = () => {
      resolve(true)
    }
    script.onerror = () => {
      resolve(false)
    }
  })

  document.head.appendChild(script)
  return promise
}

export const loadStylesheet = (sheetInfo: any) => {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  Object.entries(sheetInfo).forEach(([k, v]) => (link as any)[k] = v)

  const promise = new Promise((resolve) => {
    link.onload = () => {
      resolve(true)
    }
  })

  document.head.appendChild(link)
  return promise
}

/**
 * These css can not be lazy loaded and must be added in header of index.html
 */
const STARTUP_STYLESHEETS = [
  // {
  //   href: 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css',
  //   // it seems integrity can not be performed when inserting link using javascript
  //   // integrity: 'sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z',
  //   crossorigin: 'anonymous',
  // },
  {
    href: '/lib/fontawesome6/css/all.min.css',
  },
]

export const loadStartupStylesheets = () => {
  return Promise.all(
    STARTUP_STYLESHEETS.map((sheetInfo) => loadStylesheet(sheetInfo))
  )
}

export const STATIC_MODULES = {
  PACKER: {
    id: 'PACKER',
    path: [
      '/lib/packer.growing.js',
    ],
  },
  SVG_NEST: {
    id: 'SVG_NEST',
    path: [
      '/lib/svgPolyfill.js',
      '/lib/svgnest/util/pathsegpolyfill.js',
      '/lib/svgnest/util/matrix.js',
      '/lib/svgnest/util/clipper.js',
      '/lib/svgnest/util/parallel.js',
      '/lib/svgnest/util/geometryutil.js',
      '/lib/svgnest/util/placementworker.js',
      '/lib/svgnest/svgparser.js',
      '/lib/svgnest/svgnest.js',
    ],
  },
  POPPER: {
    id: 'POPPER',
    path: [
      '/lib/bootstrap/popper.min.js',
    ],
  },
  BOOTSTRAP: {
    id: 'BOOTSTRAP',
    path: [
      '/lib/bootstrap/bootstrap.min.js',
    ],
  },
  GIF: {
    id: 'GIF',
    path: [
      '/lib/gif/gif.js',
    ],
  },
  // polyfill.io is no longer available
  // POLYFILL: {
  //   id: 'POLYFILL',
  //   path: [
  //     'https://polyfill.io/v3/polyfill.min.js?features=Array.prototype.find,Promise,Object.assign',
  //   ],
  // },
  PMK_VIEWER: {
    id: 'PMK_VIEWER',
    path: [
      '/lib/papermaker/plugin.min.js',
    ],
  }
}

type StaticModuleGeneric = { [name: string]: { id: string, path: string[] } }

class ModuleLoader {
  modules: { [name: string]: boolean } = {}

  constructor() {
    // modules loaded state
    Object.keys(STATIC_MODULES).forEach((k) => {
      this.modules[k] = false
    })

    makeAutoObservable(this, {
      load: false,
    })
  }

  setModuleState(moduleId: string, state = true) {
    this.modules[moduleId] = state
  }

  load = (moduleId: string) => {
    const tasks = _map((STATIC_MODULES as StaticModuleGeneric)[moduleId].path, (path) => loadScript(path))
    return Promise.all(tasks).then(() => {
      this.setModuleState(moduleId)
    })
  }
}

export const StaticModules = new ModuleLoader()
